import { getCurrentInstance } from 'vue-demi';
import CONSTANTS from '../constants';
import '@futuweb/moo-ui/es/image-preview/style/css';
import {
    genDiscussionLink,
    genFeedLink,
    genStockLink,
} from '../utils/link';

const {
    common: {
        behavior: { runBehaviour }
    }
} = require('@futuweb/fego-render');

export default function useRenderClick(props) {
    const { proxy } = getCurrentInstance();
    const lang = CONSTANTS.LANG_LIST[props.contentLang];
    const discussionLink = genDiscussionLink(props.discussionId, lang);

    function onClickDiscussion() {
        const type = CONSTANTS.isMobileNN ? 'jump' : 'link';
        return runBehaviour(proxy, { type, value: discussionLink, withQuery: !CONSTANTS.isMobileNN });
    }

    function onClickDiscussionFeed(feed) {
        const link = genFeedLink(feed.id, lang);
        const type = CONSTANTS.isMobileNN ? 'jump' : 'link';
        return runBehaviour(proxy, { type, value: link, withQuery: !CONSTANTS.isMobileNN });
    }

    function onClickStockInfo($event, stockInfo) {
        $event.stopPropagation();
        const link = genStockLink(stockInfo, lang);
        const type = CONSTANTS.isMobileNN ? 'jump' : 'link';
        return runBehaviour(proxy, { type, value: link, withQuery: !CONSTANTS.isMobileNN });
    }

    return {
        onClickDiscussion,
        onClickDiscussionFeed,
        onClickStockInfo
    };
}
